module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content__section"
  }, [(_vm.props.img) ? _c('div', {
    staticClass: "block-content__img-container",
    class: {
      'block-content__img-container--right': _vm.props.right
    }
  }, [_c('img', {
    staticClass: "block-content__img",
    attrs: {
      "src": _vm.props.img
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "block-content__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21e853fc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-content/block-content.pug
// module id = 671
// module chunks = 1